import { Fragment, useMemo } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CountyLabel.scss';

export const CountyLabel = ({ label = '', workTypeName = null, ...county }) => {
    const uuid = useMemo(() => uuidv4(), []);

    if (!county || !county.name) {
        return 'Not Set';
    }

    const displayName = label || county.displayName || county.name;


    if (!county.usCountyGroups || !county.usCountyGroups.length) {
        return (
            <span>
                {displayName}
            </span>
        );
    }

    const id = `county-details-${county.id}-${uuid}`;

    return (
        <>
            <span
                id={id}
                className="county-label"
                aria-describedby={`${id}-tooltip`}
            >
                {displayName}

                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="ml-1"
                />
            </span>

            <UncontrolledTooltip
                placement="bottom"
                target={id}
                id={`${id}-tooltip`}
            >
                {workTypeName && (
                    <div className="mb-4">
                        <strong>Work Type:</strong>
                        {' '}
                        {workTypeName}
                    </div>
                )}
                This county is subject to the following local agreement(s).
                <br />

                {county.usCountyGroups.map((group) => {
                    const groupType = group.groupType || group.usCountyGroupType?.description;

                    return (
                        <Fragment key={group.id}>
                            <br />
                            {groupType}
                            :
                            {' '}
                            {group.description}
                        </Fragment>
                    );
                })}
            </UncontrolledTooltip>
        </>
    );
};